export const STATE_ISO_MAP = {
  'US-AK': 'Alaska',
  'US-AL': 'Alabama',
  'US-AR': 'Arkansas',
  'US-AZ': 'Arizona',
  'US-CA': 'California',
  'US-CO': 'Colorado',
  'US-CT': 'Connecticut',
  'US-DE': 'Delaware',
  'US-FL': 'Florida',
  'US-GA': 'Georgia',
  'US-HI': 'Hawaii',
  'US-IA': 'Iowa',
  'US-ID': 'Idaho',
  'US-IL': 'Illinois',
  'US-IN': 'Indiana',
  'US-KS': 'Kansas',
  'US-KY': 'Kentucky',
  'US-LA': 'Louisiana',
  'US-MA': 'Massachusetts',
  'US-MD': 'Maryland',
  'US-ME': 'Maine',
  'US-MI': 'Michigan',
  'US-MN': 'Minnesota',
  'US-MO': 'Missouri',
  'US-MS': 'Mississippi',
  'US-MT': 'Montana',
  'US-NC': 'North Carolina',
  'US-ND': 'North Dakota',
  'US-NE': 'Nebraska',
  'US-NH': 'New Hampshire',
  'US-NJ': 'New Jersey',
  'US-NM': 'New Mexico',
  'US-NV': 'Nevada',
  'US-NY': 'New York',
  'US-OH': 'Ohio',
  'US-OK': 'Oklahoma',
  'US-OR': 'Oregon',
  'US-PA': 'Pennsylvania',
  'US-RI': 'Rhode Island',
  'US-SC': 'South Carolina',
  'US-SD': 'South Dakota',
  'US-TN': 'Tennessee',
  'US-TX': 'Texas',
  'US-UT': 'Utah',
  'US-VA': 'Virginia',
  'US-VT': 'Vermont',
  'US-WA': 'Washington',
  'US-WI': 'Wisconsin',
  'US-WV': 'West Virginia',
  'US-WY': 'Wyoming',
}

export type State = keyof typeof STATE_ISO_MAP
export default STATE_ISO_MAP
